@if (featureFlagService.featureFlags$ | async; as featureFlags) {
  @if (featureFlags["marketDebuggerWindow"] && isAsianHandicap) {
    <button style="margin: 10px" mat-raised-button color="secondary" (click)="openDebuggerWindow()">Debug</button>
  }
}
<div class="table-wrapper">
  @if (isAsianHandicap) {
    <div class="table-header">
      @if (compactView) {
        <span>Lines: {{ firstVisibleRow + 1 }}–{{ lastVisibleRow }} (of {{ market?.runners?.length }})</span>
      } @else {
        <span>Lines: {{ market?.runners?.length }}</span>
      }
      <button (click)="toggleCompact()">
        {{ compactView ? "Show all" : "Minimize" }}
      </button>
    </div>
  }
  <div [class.scrollable-table]="isAsianHandicap" [class.compact]="compactView && isAsianHandicap" #scrollContainer (scroll)="onScroll(scrollContainer)">
    <table>
      <thead>
        @if (isAsianHandicap && compactView) {
          <tr>
            <th colspan="7">
              <button [disabled]="firstVisibleRow === 0" (click)="scrollTable(scrollContainer, -500)" class="scroll-btn">
                <mat-icon>arrow_drop_up</mat-icon>
              </button>
            </th>
          </tr>
        }
        <tr>
          <th class="runner-th">
            <app-bet-config [market]="market" />
          </th>
          @if (market?.description?.bettingType === "LINE" && (pnlCalculator.hasPlacedBets(market?.marketId) | async)) {
            <th></th>
          }
          <th class="percent-th back-th">
            {{ totalBackPercent() | percent: "1.0-2" }}
          </th>
          <th class="back-th"></th>
          <th class="text-center back-th">
            {{ market?.description?.bettingType === "LINE" ? "Under" : ("Back" | translate) }}
          </th>
          @if (wlConfigService.showLayBet(market)) {
            <th class="text-center lay-th">
              {{ market?.description?.bettingType === "LINE" ? "Over" : ("Lay" | translate) }}
            </th>
            <th class="lay-th"></th>
            <th class="percent-th lay-th">
              {{ totalLayPercent() | percent: "1.0-2" }}
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (runner of market?.runners; track trackBy(runner); let i = $index) {
          <tr class="market-runner-row" app-m-runner-row [market]="market" [data]="runner" [update]="getRunnerUpdate(runner)" [config]="config"></tr>
        }
      </tbody>
    </table>
  </div>
  @if (isAsianHandicap && compactView) {
    <button [disabled]="lastVisibleRow === market?.runners?.length" class="scroll-btn" (click)="scrollTable(scrollContainer, 500)">
      <mat-icon>arrow_drop_down</mat-icon>
    </button>
  }
</div>
